module.exports = __webpack_public_path__ + "img/orange_020.91afd4ea.png";